import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  tone?: "light" | "dark";
};
export function Countdown({
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const dark = tone === "dark";
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  return <div className="flex flex-col items-center" role="timer" aria-live="off" data-id="element-20" data-mp="3c3yz6sltcq9n">
      <p className={`flex items-center gap-2 text-sm font-bold uppercase tracking-wide ${dark ? "text-gold-300" : "text-navy-800"}`} data-id="element-21" data-mp="3h2k1cxkmlk0q">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-22" data-mp="3262mvxh53p9y" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-23" data-mp="10cbsdf39gxdq">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-24" data-mp="15bg1y6u3kx4l" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-25" data-mp="15adb1ywryuoo">
              <span className={`flex h-[68px] w-[72px] items-center justify-center rounded-xl font-serif text-[40px] font-bold tabular-nums sm:h-20 sm:w-20 sm:text-5xl ${dark ? "bg-gold-500 text-navy-900" : "bg-navy-900 text-white"}`} data-id="element-26" data-mp="y16mhehpwdst">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? "text-white/70" : "text-muted"}`} data-id="element-27" data-mp="12t7u2n3xxgci">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-bold ${dark ? "text-gold-400" : "text-navy-900"}`} data-id="element-28" data-mp="a5kc7fu213tk">:</span>}
          </React.Fragment>)}
      </div>
      <p className={`mt-2 text-sm font-medium ${dark ? "text-white/70" : "text-muted"}`} data-id="element-29" data-mp="k03y2v392req">Limited-time launch pricing</p>
    </div>;
}